var _path, _polyline, _polyline2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorExitEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.401,16.557l2.656-1.271c.981-.469,2.105-.545,3.14-.212l.784.253c.471.152.912.384,1.303.688l.814.631c.598.464,1.061,1.078,1.343,1.781h0c.502,1.255,1.571,2.196,2.879,2.536l1.905.495"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "23.83 16.437 20.422 22.136 24.168 25.363 21.936 31.58"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "18.971 23.507 16.957 25.523 11.775 25.523"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.12,
    cy: 12.652,
    r: 2.231
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18.549
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorExitEmergency);
export default __webpack_public_path__ + "static/media/indoor-exit-emergency.a6da058b9538e10eda88507c34e8bfe9.svg";
export { ForwardRef as ReactComponent };